import styled from 'styled-components';
import { colors } from '../../utils';
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { device } from '../../utils/device';

export const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 50vw;
  min-width: 600px;
  max-width: 800px;
  box-shadow: 24px 24px 48px rgba(0, 0, 0, 0.2);
  padding: 30px;
  gap: 16px;
  border-radius: 14px;
  background-color: white;
  background-size: cover;
  position: relative; /* Relative position to use as a reference for children */
`;

export const ModalContent = styled.div`
  padding-top: 48px;
  padding-bottom: 48px;
`;

// Header Section with Title and Close Icon
export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
  margin-bottom: 10px;
  .close-icon {
    cursor: pointer;
    color: #757575;
    transition: color 0.2s;

    &:hover {
      color: #000;
    }
  }
`;

export const PromptAndMediaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #E1E1E1;
`

// Input Area for Text Input
export const TextInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  textarea {
    width: 100%;
    height: 100px;
    resize: none;
    border: none;
    border-bottom: 1px solid #E1E1E1;
    padding: 10px;
    font-size: 14px;

    &:focus {
      outline: none;
      border-color: #6200ee; /* Purple accent for focus */
    }
  }
`;

// File Attachment Section
export const AttachFilesWrapper = styled.div`
  display: grid;
  grid-template-columns: auto 20px auto auto;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
`;

export const TokenAvailabilityContainer = styled.div`
  display: flex;
  border-radius: 8px;
  border: 1px solid #EAECF0;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  background-color: #F9FAFB;
`;

export const TokensContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 50%;
`
export const TokensHeadingContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`

export const Separator = styled.div`
  width: 1px;
  height: 13px;
  background-color: #565556;
`

export const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 5px;
  align-self: flex-end;
`

export const UpgradeText = styled.div`
  font-size: 12px;
  color: ${colors.PrimaryPurple};
  font-weight: 600;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  white-space: nowrap;
`

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 12px;
  border-top: 0.5px solid #bbbbbb;
  padding-top: 20px;
  margin-top: 20px;

  button {
    flex: 1;
    border-radius: 8px;
    border: none;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.3s ease;

    &.reset {
      background-color: #ffffff;
      color: #0f52ba;
    }

    &.cancel {
      background-color: #ffffff;
      color: #757575;

      &:hover {
        background-color: #e0e0e0;
      }
    }

    &.generate {
      background-color: #9b5af8;
      color: white;

      &:hover {
        background-color: #9b5af8;
      }
    }
  }
`;

export const SliderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  background-color: rgba(246, 247, 249, 1); /* Grey background */
  gap: 5px; /* Space between the sliders */
  padding: 14px;
  border-radius: 8px;

  > div {
    flex: 1; /* Ensure sliders take equal space */
    max-width: 30%; /* Optional: Limit slider width */
  }
`;

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 12px;
  }
`;

export const StyledDialogContent = styled(DialogContent)`
  display: flex;
  gap: 24px;
  flex-direction: column;
  padding-left: 16px;
  padding-right: 16px;
`;

export const StyledDialogTitle = styled(DialogTitle)`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 0 0 0;
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;

  img {
    width: 24px;
    height: 24px;
  }
`;

export const Content = styled.div`
  margin-bottom: 24px;
  color: #666;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const DialogButtonContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto;
  justify-content: flex-end;
  grid-gap: 10px;

  @media ${device.mobilePortrait} {
    flex-direction: column;
  }
`;
